import { useRouteMatch } from 'react-router-dom';
import { TransactionDrawerRouter } from 'assets/js/pages/transactions/TransactionDrawerRouter';
import { Transactions } from 'assets/js/pages/transactions/Transactions';
import { TransactionsDetailsFormDrawer } from 'assets/js/pages/transactions/TransactionsOfflineFormDrawer';
import { DrawerRoute } from 'components/drawer-route';
import { Route } from 'components/router/Route';

const TransactionsRouter = () => {
    const match = useRouteMatch();

    return (
        <>
            <DrawerRoute
                path={`${match.path}/:transaction_id(\\d+)`}
                component={TransactionDrawerRouter}
            />
            <DrawerRoute path={`${match.path}/new`} component={TransactionsDetailsFormDrawer} />
            <Route path={match.path} component={Transactions} />
        </>
    );
};

export default TransactionsRouter;
